import Lenis from "lenis"

// $headerHeight in elements.scss plus the 20px breathing room that #projects
// sets as scroll-margin-top. Lenis positions the target itself and doesn't
// read scroll-margin, so the value has to be repeated here.
const HEADER_OFFSET = 86

let instance = null
let frame = null

// One instance for the whole site, started from gatsby-browser rather than
// Layout — Layout unmounts on every navigation and would tear Lenis down
// with it.
export const initSmoothScroll = () => {
	if (instance || typeof window === "undefined") return instance

	// Smoothing the scroll is exactly the kind of added movement this setting
	// asks us to leave out.
	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return null
	}

	instance = new Lenis({
		// Touch keeps the platform's own scrolling. Smoothing it fights the
		// drag-to-rotate hero and feels wrong against the rubber band.
		syncTouch: false,
	})

	const raf = (time) => {
		instance.raf(time)
		frame = requestAnimationFrame(raf)
	}
	frame = requestAnimationFrame(raf)

	return instance
}

export const destroySmoothScroll = () => {
	if (frame) cancelAnimationFrame(frame)
	instance?.destroy()
	instance = null
	frame = null
}

// Re-measure the scrollable height. The ResizeObserver inside Lenis covers
// this on its own, but a route change swaps the whole page at the same moment
// the transition is animating, which is the case that goes wrong.
export const refreshSmoothScroll = () => {
	instance?.resize()
}

// Native scrollIntoView is the fallback throughout, so reduced-motion users
// and any failed init still get working anchors.
export const scrollToHash = (hash) => {
	const target = document.querySelector(hash)
	if (!target) return

	if (instance) {
		instance.scrollTo(target, { offset: -HEADER_OFFSET })
		return
	}

	// scroll-margin-top handles the offset on this path.
	target.scrollIntoView({ behavior: "smooth" })
}

// Route changes should land instantly — easing the whole page back to the top
// on every navigation reads as lag, not polish.
export const jumpTo = (y = 0) => {
	if (instance) {
		instance.scrollTo(y, { immediate: true })
		return
	}

	window.scrollTo(0, y)
}
